import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import dynamic from "next/dynamic";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { LogoList, MgpWrapper, CarigamiWrapper } from "./CarigamiGarantie.styles";
var Garantie = dynamic(function() {
    return import("./Garantie").then(function(module) {
        return module.Garantie;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("./Garantie")
            ];
        }
    }
});
var CarigamiGarantie = function() {
    return /*#__PURE__*/ _jsxs(LogoList, {
        children: [
            /*#__PURE__*/ _jsx(MgpWrapper, {
                children: /*#__PURE__*/ _jsx(Garantie, {})
            }, "gmp"),
            /*#__PURE__*/ _jsx(CarigamiWrapper, {
                children: /*#__PURE__*/ _jsx(UiLegacy.ImageSVG, {
                    name: "cg"
                })
            }, "carigami")
        ]
    });
};
export { CarigamiGarantie };
